import { Component, computed, input, output, viewChild } from '@angular/core';
import {
	UiAlertComponent,
	UiButtonComponent,
	UiChipComponent,
	UiNumberComponent,
	UIIconComponent
} from '@design-system';
import { BottomSheetComponent } from '../../../../components/bottom-sheet/bottom-sheet.component';
import {
	TRANSFER_STEP_CIRCLE_CLASSES,
	TRANSFER_STEP_LINE_CLASSES,
	TRANSFER_STEP_TITLE_CLASSES
} from '../wallet-transfer-history.constants';
import type { TransferHistoryItem } from '../wallet-transfer-history.model';
import { transferStateKey } from '../wallet-transfer-history.utils';

@Component({
	selector: 'app-wallet-transfer-detail-bottom-sheet',
	imports: [
		BottomSheetComponent,
		UiAlertComponent,
		UiButtonComponent,
		UiChipComponent,
		UiNumberComponent,
		UIIconComponent
	],
	templateUrl: './wallet-transfer-detail-bottom-sheet.component.html',
	host: { 'data-cy': 'wallet-transfer-detail-bottom-sheet' }
})
export class WalletTransferDetailBottomSheetComponent {
	readonly request = input<TransferHistoryItem | null>(null);
	readonly closed = output<void>();

	/**
	 * The step the state chip sits on: the one the transfer stopped at, else the last one while
	 * the request is not through — that step may already be ticked, as a request sent to
	 * بورس کالا is.
	 */
	readonly chipStepIndex = computed(() => {
		const request = this.request();
		const steps = request?.timeline.steps ?? [];
		const failed = steps.findIndex(step => step.status === 'failed');
		const last = steps.length - 1;
		const unfinished =
			!!request && (steps[last]?.status !== 'done' || transferStateKey(request.state) !== 'completed');

		return failed !== -1 ? failed : unfinished ? last : -1;
	});

	/** Exposed to the template: what each step status is drawn with. */
	readonly stepCircles = TRANSFER_STEP_CIRCLE_CLASSES;
	readonly stepTitles = TRANSFER_STEP_TITLE_CLASSES;
	readonly stepLines = TRANSFER_STEP_LINE_CLASSES;

	private readonly sheet = viewChild<BottomSheetComponent>('sheet');

	open(): Promise<void> {
		return this.sheet()?.open() ?? Promise.resolve();
	}

	close(): Promise<void> {
		return this.sheet()?.close() ?? Promise.resolve();
	}
}
